import { client } from "@/config/client"

interface SaveConfidenceIndexParams {
  cardId: string
  body: {
    quality: number
  }
}

export default function saveConfidenceIndex({ cardId, body }: SaveConfidenceIndexParams) {
  return client.put(`/v1/flashcards/update-factors/${cardId}`, body)
}
